/**
 * The homepage FAQ is `faq.home.items.0` … `faq.home.items.{HOME_FAQ_COUNT - 1}`
 * in the translation files. The visible list (`FaqSection`) and the FAQPage
 * JSON-LD on the homepage both read this count, so a new item shows up in
 * both or in neither.
 */
export const HOME_FAQ_COUNT = 11;

/** The item whose answer quotes plan prices and takes ICU params. */
export const HOME_FAQ_PRICING_INDEX = 9;

export const HOME_FAQ_INDICES = Array.from(
	{ length: HOME_FAQ_COUNT },
	(_, i) => i,
);
